import { render } from "./MonthlyChartsApex.vue?vue&type=template&id=09cfc9b0&scoped=true"
import script from "./MonthlyChartsApex.vue?vue&type=script&lang=js"
export * from "./MonthlyChartsApex.vue?vue&type=script&lang=js"

import "./MonthlyChartsApex.vue?vue&type=style&index=0&id=09cfc9b0&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cfc9b0"]])

export default __exports__